import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WalletIcon } from 'lucide-react';
export function BudgetBagService() {
  return <div className="w-full min-h-screen bg-white" data-id="element-212">
      <Header data-id="element-213" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-214">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5WvzYSTcKMKg9dMTBVFpMR/BudgetBagService.jpg" alt="Budget Bag Service" className="w-full h-full object-cover" data-id="element-215" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-216"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-217">
          <div className="text-center" data-id="element-218">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-219">
              <WalletIcon className="w-10 h-10 text-[#E41C1C]" data-id="element-220" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-221">
              Budget Bag Service
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-222">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
          <div className="space-y-6" data-id="element-224">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-225">
              Our Budget Bag Service offers the ultimate flexibility for those
              who don't need weekly pickup. Perfect for seniors, seasonal
              residents, or anyone who generates minimal waste, this service
              lets you pay only for what you use—no contracts, no minimums, no
              monthly fees. Simply purchase bags in packs of ten from
              participating local businesses, fill them when needed, and set
              them out for collection.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-226">
              This service is ideal for cottages, hunting cabins, or homes where
              residents are away for extended periods. You're in complete
              control of your waste management costs, and there's no pressure to
              commit to a long-term service plan. The bags are durable and
              designed to handle typical household waste, making disposal
              straightforward and stress-free.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-227">
              By purchasing your bags locally, you're also supporting other
              small businesses in the community. It's a win-win solution that
              reflects our commitment to serving neighbors in a way that makes
              sense for their unique situations. Whether you need one bag a
              month or ten, we're here to accommodate your needs without locking
              you into a contract.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-228">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-229">
              Where to Buy Budget Bags
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-230">
              Contact us to find the nearest location selling Sam's Disposal
              budget bags.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-231">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-232">
                Call (231) 796-2952
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-233" />
    </div>;
}